import { Theme } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(({
  breakpoints,
  fontWeights,
  palette,
  fontFamilies,
}: Theme) => ({
  banner: {
    paddingTop: '2rem',
    paddingBottom: '1rem',
    background: 'linear-gradient(270deg, #00a3e0 0%, #0a7cc1 35.5%, #0a7cc1 65%, #00a3e0 100%)',
    overflow: 'hidden',
    [breakpoints.up('md')]: {
      height: '20.5rem',
      paddingTop: 0,
      paddingBottom: 0,
    },
    '& > div': {
      display: 'flex',
      flexDirection: 'column',
      [breakpoints.up('md')]: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'flex-end',
        height: '100%',
      },
      [breakpoints.up('xl')]: {
        paddingRight: '5%',
      },
    },
  },
  wrapper: {
    display: 'flex',
    flexDirection: 'column',
    [breakpoints.up('md')]: {
      justifyContent: 'center',
      width: '54%',
      height: '100%',
      paddingTop: '2.5rem',
      paddingBottom: '2.5rem',
    },
    [breakpoints.up('xl')]: {
      maxWidth: '32.5rem',
    },
  },
  image: {
    display: 'block',
    width: 'auto',
    height: '16.25rem',
    margin: '1rem auto 0',
    [breakpoints.up('md')]: {
      margin: 0,
      width: '17.5rem',
      height: 'unset',
      objectFit: 'contain',
    },
    [breakpoints.up('xl')]: {
      position: 'relative',
      bottom: '-1.25rem',
      width: '18.5rem',
    },
  },
  title: {
    margin: '0 0 0.5rem',
    color: palette.common.white,
    fontSize: '1.5rem',
    fontWeight: fontWeights.medium,
    lineHeight: 1.2,
    [breakpoints.up('md')]: {
      marginBottom: '1.5rem',
    },
    [breakpoints.up('lg')]: {
      fontSize: '2.25rem',
      lineHeight: 1.5,
    },
  },
  description: {
    margin: 0,
    color: palette.common.white,
    fontSize: '1rem',
    lineHeight: 1.4,
    [breakpoints.up('lg')]: {
      fontSize: '1.125rem',
      lineHeight: 1.4,
    },
  },
  content: {
    position: 'relative',
    margin: '-1rem 0 1.5rem',
    paddingTop: '2rem',
    fontSize: '0.875rem',
    lineHeight: 1.3,
    borderTopLeftRadius: '1rem',
    borderTopRightRadius: '1rem',
    backgroundColor: palette.common.white,
    [breakpoints.up('md')]: {
      marginTop: '1.5rem',
      paddingTop: 0,
    },
    [breakpoints.up('lg')]: {
      marginTop: '4rem',
      marginBottom: '8rem',
    },
    [breakpoints.up('xl')]: {
      fontSize: '1.125rem',
      lineHeight: 1.4,
    },
  },
  notes: {
    listStyle: 'none',
    margin: 0,
    paddingBottom: '0.5rem',
    [breakpoints.up('md')]: {
      paddingBottom: '8rem',
    },
    '& li': {
      fontSize: '0.875rem',
      lineHeight: 1.4,
    },
    '& li:not(:last-child)': {
      marginBottom: '0.5rem',
    },
    '& li:first-child': {
      paddingTop: '0.75rem',
      borderTop: `1px solid ${palette.grey[400]}`,
      [breakpoints.up('lg')]: {
        paddingTop: '4rem',
        borderColor: palette.common.black,
      },
    },
  },
  link: {
    color: '#0a5f72',
    fontFamily: fontFamilies.medium,
    fontWeight: fontWeights.medium,
    textDecoration: 'underline',
    wordBreak: 'break-word',
  },
  lists: {
    display: 'flex',
    flexDirection: 'column',
    gap: '1.5rem',
    marginBottom: '0.75rem',
    [breakpoints.up('lg')]: {
      gap: '8rem',
      marginBottom: '8rem',
    },
  },
  layout: {
    width: '100%',
    maxWidth: '73.25rem',
    paddingLeft: '1rem',
    paddingRight: '1rem',
    marginLeft: 'auto',
    marginRight: 'auto',
  },
  legal: {
    margin: '0 0 2.5rem',
    color: '#777',
    fontSize: '0.875rem',
    lineHeight: 1.4,
    textAlign: 'center',
    [breakpoints.up('md')]: {
      marginBottom: '4rem',
    },
  },
}));
